import { render, staticRenderFns } from "./OperationDetailsForm.vue?vue&type=template&id=3257f746"
import script from "./OperationDetailsForm.vue?vue&type=script&lang=js"
export * from "./OperationDetailsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports